/**
 * 事件跟踪SDK对象
 */
const trackSDK = {
  client: null,
  initingPromise: null,
}

/**
 * 判断是否存在事件跟踪SDK
 */
export const hasTrackSDK = () => {
  // @ts-ignore
  return !!window.StarTrack
}

/**
 * 获取事件跟踪SDK
 */
export const getTrackSDK = () => {
  if (trackSDK.client) return trackSDK.client
  // @ts-ignore
  const windowStarTrack = window.StarTrack as any

  trackSDK.client = windowStarTrack.createInstance
    ? windowStarTrack.createInstance()
    : new windowStarTrack.__proto__.constructor()
  return trackSDK.client
}

/**
 * 初始化事件跟踪SDK
 */
export const initTrackSDK = (params: any) => {
  // @ts-ignore
  trackSDK.initingPromise = getTrackSDK()
    .init(params, {
      setting: {
        devMode: params.devMode,
        eventLimit: 1,
        storePrefix: 'st_pay:',
      },
    })
    .then(() => {
      trackSDK.initingPromise = null
    })
}

/**
 * 上报事件
 */
export const trackEvent = async (data: any) => {
  if (trackSDK.initingPromise) await trackSDK.initingPromise

  const { deviceData } = getTrackSDK()
  const { st_device_id } = deviceData

  getTrackSDK().event(
    {
      ...data,
      // 覆盖设备id
      st_distinct_id: st_device_id,
    },
    { addDeviceInfo: true }
  )
}
